import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveZonesProjectsGanttRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveZonesProjectsGanttRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveZonesProjectsGanttRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getZonesProjectsGantt() {
      return getState().gantt;
    },
  };
}

export { createSelector };
